exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".c-logo{color:tomato;display:inline-block;font-size:1.5rem;line-height:1.3;font-weight:700;text-align:left;text-transform:lowercase;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}@media (min-width:60em){.c-logo{font-size:2.369rem;line-height:1.2}}.c-logo{position:relative}.c-logo:before{content:\"\\A9\";display:inline-block;position:absolute;left:-.825em;top:0}", ""]);

// exports
